module.exports = "/_next/static/images/more_monthly-reports-0998542f2cae665a51d138e4c7b32c18.jpg";